module.exports = __webpack_public_path__ + "img/3.2a67328e.png";